import Cancellation from './Cancellation.vue';

export default Cancellation;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/components/cancellation/index.ts